module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_6-d37fba3d4a5e711d6a60eba2b7c3b196.png";